import React from 'react';
import { Common18NextProvider } from 'lidya-common-components';
import PropTypes from 'prop-types';
import i18n from './i18nSimple';
import GlobalDataProvider from '../../providers/globalDataProvider/globalDataProvider.provider';
import '../../styles/global.less';

export const TopChildrenWrapper = function ({ pageContext, location, children }) {
  return (

    <Common18NextProvider i18n={i18n}>
      {/* <Responsive> */}
      <GlobalDataProvider pageContext={pageContext} location={location}>
        {children}
      </GlobalDataProvider>
      {/* </Responsive> */}
    </Common18NextProvider>

  );
};

TopChildrenWrapper.propTypes = {
  children: PropTypes.oneOfType([PropTypes.elementType, PropTypes.shape([])])
    .isRequired,
  location: PropTypes.shape({}).isRequired,
  pageContext: PropTypes.shape({}).isRequired,
};

export default TopChildrenWrapper;
